<template>
	<div class="site-invoice-info">
		<div class="vx-row">
			<div class="vx-col w-full md:w-1/2">
				<div class="logo-block">
					<div class="logo-block__container">
						<div class="logo-block__logo">
							<div
								v-if="!model.invoice_logo || isEditingLogo"
								class="logo-block__upload"
							>
								<LogoUpload
									:text="$t('loadFile')"
									@change="changeLogo"
								/>
							</div>
							<img
								v-else
								class="logo-block__img"
								:src="model.invoice_logo"
							>
						</div>
						<div class="logo-block__controls vx-row">
							<div class="vx-col w-1/2">
								<vs-custom-button
									:disabled="!model.invoice_logo"
									@click="isEditingLogo = !isEditingLogo"
									class="logo-block__btn w-full pl-1 pr-1"
								>
									{{ changeLogoBtnText }}
								</vs-custom-button>
							</div>

							<div class="vx-col w-1/2">
								<vs-custom-button
									:disabled="!model.invoice_logo"
									@click="model.invoice_logo = ''"
									type="border"
									color="danger"
									class="logo-block__btn w-full pl-1 pr-1"
								>{{ $t('deleteLogo') }}</vs-custom-button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<label class="site-invoice-info__label">{{ $t('firmInfo') }}</label>
				<vs-textarea
					v-model="model.about_text"
					v-validate="'required'"
					name="about_text"
					height="200px"
					class="mb-0"
				/>
				<span v-if="errors.first('about_text')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<label class="site-invoice-info__label">{{ $t('termsAndConditions') }}(1 {{ $t('part') }})</label>
				<vs-textarea
					v-model="model.terms_text"
					v-validate="'required'"
					name="terms_text"
					height="200px"
					class="mb-0"
				/>
				<span v-if="errors.first('terms_text')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
			<div class="vx-col w-full md:w-1/2">
				<label class="site-invoice-info__label">{{ $t('termsAndConditions') }}(2 {{ $t('part') }})</label>
				<vs-textarea
					v-model="model.terms_text_two"
					v-validate="'required'"
					name="terms_text_two"
					height="200px"
					class="mb-0"
				/>
				<span v-if="errors.first('terms_text_two')" class="text-danger text-sm">
					{{ $t('fieldFilledIncorrect') }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import LogoUpload from "@/components/LogoUpload";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
// import { VueEditor } from "vue2-editor";

export default {

	name: "SiteInvoiceInfo",
	mixins: [databaseManager, notifier],
	props: {
		model: { required: true },
		validate: {required: true, type: Boolean }
	},
	components: {
		LogoUpload,
		// VueEditor
	},
	data() {
		return {
			isEditingLogo: false,
			text: ""
		};
	},
	watch: {
		validate() {
			this.makeValidate()
		}
	},
	computed: {
		changeLogoBtnText() {
			return this.isEditingLogo ? this.$t('cancel') : this.$t('changeLogo');
		}
	},
	methods: {
		makeValidate() {
			if(!this.validate) return;

			const entries = Object.entries(this.model);
			if(entries.length && this.validate) {
				this.$validator.validateAll();
			}
		},
		async changeLogo(path, files) {
			try {
				const data = [files[files.length - 1]];
				const res = await this.dbUploadMany(data);
				this.model.invoice_logo = res[0].fullUrl;
				this.isEditingLogo = false;

			} catch(e) {
				this.notifyError(e.message);
			}
		}
	},
	mounted() {
		this.makeValidate()
	}
};
</script>

<style lang="scss" scoped>
.site-invoice-info {
	&__label {
		font-size: 0.85rem;
		margin-left: 5px;
		color: rgba(0, 0, 0, 0.7);
	}

	& .logo-block {
		margin-top: 20px;
	}

	.logo-block {
		flex: 320px 1 0;

		&__container {
			width: 100%;
			max-width: 320px;
		}

		&__upload {
			width: 100%;
			height: 100%;
		}

		&__controls {
			display: flex;
		}

		&__btn {
			margin-top: 15px
		}

		&__logo {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 140px;
			background-color: #eeeeee;
			border-radius: 10px;
			overflow: hidden;
		}

		&__img {
			max-width: 100%;
			max-height: 100%;
		}
	}

	& > .vx-row > .vx-col {
		margin-top: 25px;
	}

	@media screen and (max-width: 768px) {
		& > .vx-row > .vx-col {
			&:first-child {
				margin-top: 0;
				margin-bottom: 16px;
			}
		}

		& .logo-block {
			margin-top: 0;
		}
	}
}
</style>
